import { FormlyFieldConfig } from "@ngx-formly/core";

export const validationMsgs = {
    name: "Name field is required.",
    alphaOnly: (error: any, field: FormlyFieldConfig) => `${field?.props?.[ "title" ]} only accepts letters.`,
    alphaOnlyOptional: "Numbers are not allowed in this field.",
    alphaNumeric: (error: any, field: FormlyFieldConfig) => `${field?.props?.[ "title" ]} only accepts numbers, letters, spaces, hyphens and full stops.`,
    alphaNumericOptional: (error: any, field: FormlyFieldConfig) => `${field?.props?.[ "title" ]} only accepts numbers, letters, spaces, hyphens and full stops.`,
    email: "Please type your email address in the format yourname@example.com.",
    emailSame: "Email cannot be the same as lead applicant",
    postcode: "Please enter a valid UK postal code (including space)",
    phone: "Please enter a valid UK phone number",
    niNumber: "The NI Number should be in this format. XX 00 00 00 X.",
    organisation: "An organisation name less than 50 characters is required."
}
